import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ServicesPage from './pages/ServicesPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';

function App() {
  return (
    <Router>
      <Routes>        
        <Route path='/' element={<AboutPage />} />
        <Route index path='about' element={<AboutPage />} />
        <Route path='services' element={<ServicesPage />} />
        <Route path='contact' element={<ContactPage />} />
      </Routes>
    </Router>
  );
}

export default App;
